function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Group_4557",
  "data-name": "Group 4557",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24"
}, props), /*#__PURE__*/React.createElement("path", {
  id: "Path_2362",
  "data-name": "Path 2362",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2363",
  "data-name": "Path 2363",
  d: "M19.376 12.416l-10.6 7.066A.5.5 0 018 19.066V4.934a.5.5 0 01.777-.416l10.6 7.066a.5.5 0 010 .832z",
  fill: "#fff"
})));